import React, { useState, useEffect } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useAlert } from 'hooks';
import AlertModal from 'components/AlertModal';
import {
  getAllSolicitudesFormaPago,
} from '../../features/formapago/formapagoAPI';
import {
  FormaPagoRequest,
} from 'types/FormaPago';

export default function ListFormasPago() {
  const [solicitudes, setSolicitudes] = useState<FormaPagoRequest[]>([]);

  const [showAlert, message, alert] = useAlert(false, '');

  useEffect(() => {
    getAllSolicitudesFormaPago()
      .then(response => {
        setSolicitudes(response);
      })
      .catch(err => {
        alert(
          true,
          err.getMessage() || 'No se puedieron obtener las solicitudes de facturación en OOSS del matriculado',
        );
      });
  }, []);

  const getFormaPagoString = (formaPago: string) => {
    switch (formaPago) {
      case 'Efectivo':
        return 'Efectivo';
      case 'Bancaria':
        return 'Bancaria CBU';
      case 'Tarjeta':
        return 'Tarjeta de Crédito';
      default:
        return '';
    }
  };

  return (
    <div className="content">
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={() => alert(false)}
      />
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col md={8} style={{ fontSize: '1.5rem', marginTop: '10px' }}>
                  Solicitudes de Modificación de Forma de Pago de la Matrícula
                </Col>
                <Col md={4} className="text-right">
                  <Link
                    to={{ pathname: '/forma-pago/create' }}
                    className="btn btn-primary btn-round"
                  >
                    Nueva Solicitud
                  </Link>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Table>
                <thead>
                  <tr>
                    <th>Forma de Pago</th>
                    <th>Tipo de Tarjeta</th>
                    <th>Nro. Tarjeta / CBU</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    solicitudes.map(row => (
                      <tr key={ `row_${ row.id }` }>
                        <td>{ getFormaPagoString(row.forma_pago ?? '') }</td>
                        <td>{ row.tipo_tarjeta ?? '' }</td>
                        <td>{ row.numero_tarjeta_cbu ?? '' }</td>
                        <td>{ row.state?.name }</td>
                        <td>
                          { [3].includes(row.state?.id || 0)
                            ?
                              <Link
                                to={`/forma-pago/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Editar'
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            :
                              <Link
                                to={`/forma-pago/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Ver'
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                          }
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
